import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import {
	CreateRelativeRequest,
	Relative,
	RelativeAccess,
} from "src/types/types";

@Injectable({
	providedIn: "root",
})
export class RelativeService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiBaseUrl = environment.NewApiPath.replace(/\/$/, "");

	getRelatives(): Observable<Relative[]> {
		return this.httpClient.get<Relative[]>(
			`${this.apiBaseUrl}/users/self/relatives`,
		);
	}

	createRelative(request: CreateRelativeRequest): Observable<Relative> {
		return this.httpClient.post<Relative>(
			`${this.apiBaseUrl}/users/self/relatives`,
			request,
		);
	}

	updateRelativeAccess(
		relativeUserId: string,
		access: RelativeAccess,
	): Observable<Relative> {
		return this.httpClient.put<Relative>(
			`${this.apiBaseUrl}/users/self/relatives/${relativeUserId}`,
			access,
		);
	}

	deleteRelative(relativeUserId: string): Observable<void> {
		return this.httpClient.delete<void>(
			`${this.apiBaseUrl}/users/self/relatives/${relativeUserId}`,
		);
	}
}
